import { render } from "./Error_c.vue?vue&type=template&id=5e6fff00"
import script from "./Error_c.vue?vue&type=script&lang=js"
export * from "./Error_c.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/takayama_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__